import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, from, map, of } from 'rxjs';
import { UserManagementService } from '../../../modules/user/shared/services/user-management/user-management.service';
import { GridUser } from '../../../modules/user/shared/models/grid-user';
import { UserStatus } from '../../models/user-status';
import { GuardDataKeys } from '../constants/guard-constants';

@Injectable({
    providedIn: 'root',
})
export class UserStatusGuard {
    constructor(
        private readonly userManagementService: UserManagementService,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const userId = route.paramMap.get('id');
        if (!userId) {
            return of(false);
        }

        return from(this.userManagementService.get(+userId)).pipe(
            map((gridUser: GridUser) => {
                const permittedUserStatuses =
                    route.data[GuardDataKeys.PERMITTED_USER_STATUSES];
                return permittedUserStatuses.includes(
                    UserStatus.getUserStatus(gridUser.user),
                );
            }),
            catchError((error) => {
                console.error('Error fetching user:', error);
                return of(false);
            }),
        );
    }
}
